import styles from "./PageContainer.module.scss"
import { PageContainerProps } from "./PageContainer.types"

export default function PageContainer(props: PageContainerProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
